// src/components/Auth/MsalRedirectHandler.tsx
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const MsalRedirectHandler = () => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response?.account) {
        instance.setActiveAccount(response.account);
      }
    });
  }, [instance]);

  return null;
};

export default MsalRedirectHandler;
